import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Button , Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

const styles = theme => ({
  modalDiv: {
    maxWidth: '350px',

    '& .ant-modal-header': {
      borderBottom: 0,
      padding: '15px',
    },

    '& .ant-modal-body': {
      padding: '15px',
    },

    '& .ant-modal-footer': {
      borderTop: 0,
      padding: '15px',
    },
  },
});

class DeleteBidConfirmationModal extends React.PureComponent<any, any> {
  render() {
    const { visible, handleOk, handleCancel, loading, ffName, classes,
      commentVisible, onChangeReason , value} = this.props;
    return (
      <Modal
        className={classes.modalDiv}
        title= {commentVisible ? 'Add Comment' : 'Delete Bid'}
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel} >
            {!commentVisible ? 'No' : 'Cancel'}
          </Button>,
          <Button key="submit" type="primary"  onClick={handleOk} loading={loading}>
            {!commentVisible ? 'Yes' : 'Submit'}
          </Button>,
        ]}
        >
          {
            commentVisible ?
              <Form.Item>
                <TextArea placeholder="Type here to add reason for deletion of Bid!"
                onChange={onChangeReason}
                rows={3} />
            </Form.Item> :
            <p>
              Deleting this bid will remove the associated data and {ffName} will be notified with the reason.
              Are you sure you want to proceed?
            </p>
          }
      </Modal>
    );
  }
}

export default injectSheet(styles)(Form.create()(DeleteBidConfirmationModal));
